import React from 'react';
import { ToggleProps } from './ToggleProps.d';


const Toggle: React.FC<ToggleProps> = ({ checked, onChange, className = '' }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={onChange}
      className={`${
        checked ? 'bg-brandColor' : 'bg-gray-200'
      } inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brandColor focus:ring-offset-2 ${className}`}
    >
      <span
        className={`${
          checked ? 'translate-x-6' : 'translate-x-1'
        } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
      />
    </button>
  );
};
export default Toggle;